import { getClusterBaggage, getCustomClusterBaggage } from './available';

import { baggageCustomFilter } from './custom';
import { baggageSimpleFilter } from './simple';

export const baggageFilter = (searchResults, baggageSelected, isCustom) => {
  if (!baggageSelected || baggageSelected === 'backpack_baggage') {
    return [...searchResults];
  }

  const filterByType = isCustom ? baggageCustomFilter : baggageSimpleFilter;
  return filterByType(searchResults, baggageSelected);
};

export const getBaggageBySearchType = isCustomSearch =>
  isCustomSearch ? getCustomClusterBaggage : getClusterBaggage;
